import firebaseService from '@ameroservices-platform/shared/services/firebase';

export const resyncItemsToSyncEngine = async (type, destination) => {
	const data = await firebaseService.callFunctionByName('sysAdminResyncItemsToSyncEngine', {
		type,
		destination,
	});
	return data && data.data ? data.data : null;
};
